import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { AppNavList } from './AppNavList';
import LogoComponent from './Logo';
import { useTheme } from '@mui/material';
import MobileMenu from './MobileMenu';
import { IRoute } from '../../config/appRoutes';
import { PopupSettingsMenu } from './PopupSettingsMenu';
import { SignalRStatusIndicator } from './SignalRStatusIndicator';
import { isCloud } from '../../utils/urlUtils';

interface NavigationProps {
  appRoutes: IRoute[];
}

export const Navigation: React.FC<NavigationProps> = ({ appRoutes }) => {
  const { palette } = useTheme();

  return (
    <AppBar
      sx={{
        border: `1px solid ${palette.divider}`,
        minHeight: '54px',
      }}
      position="static"
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          '@media (min-width: 600px)': {
            minHeight: '54px',
          },
          padding: '0 16px',
        }}
        disableGutters
      >
        <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
          <LogoComponent />
        </Box>
        <MobileMenu appRoutes={appRoutes} />
        <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1, justifyContent: 'center' }}>
          <LogoComponent />
        </Box>
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
          <AppNavList appRoutes={appRoutes} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {!isCloud() && <SignalRStatusIndicator />}
          <PopupSettingsMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
